// extracted by css-extract-rspack-plugin
export default {"form":"form-wLLky7"};